import { IMAGES } from "@/components/shared";

const CARDS = [
  {
    image: IMAGES.cat6,
    alt: "Precision cable management in a commercial server cabinet",
    label: "Structured Cabling",
    text: "Cat6A & Fiber Splicing with OTDR verification.",
  },
  {
    image: IMAGES.av,
    alt: "Wall-mounted flush display with concealed audio wiring",
    label: "Audio / Video",
    text: "Zero-wire visibility TV mounting & acoustic alignment.",
  },
  {
    image: IMAGES.ai,
    alt: "Custom automation workflow node graph on screen",
    label: "AI & Workflows",
    text: "Automated lead routing & customer engagement agents.",
  },
];

export default function Gallery() {
  return (
    <section className="py-16 bg-[#0e0e12] border-y border-[#d4af37]/15" data-testid="gallery-section">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10">
          <div>
            <span className="text-xs font-mono uppercase tracking-widest text-[#d4af37]">Field Standards</span>
            <h2 className="font-display text-3xl uppercase text-white mt-1">Real-World Installation Quality</h2>
          </div>
          <p className="text-xs text-zinc-400 font-mono mt-2 md:mt-0">DFW Residential · Commercial Offices · Data Centers</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CARDS.map((c) => (
            <div key={c.label} className="rounded-xl overflow-hidden bg-[#121216] border border-zinc-800 group">
              <div className="aspect-[4/3] overflow-hidden bg-[#09090b]">
                <img
                  src={c.image}
                  alt={c.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <span className="text-[10px] font-mono text-[#d4af37] uppercase">{c.label}</span>
                <p className="text-xs text-zinc-200 mt-1 font-medium">{c.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
